import React from 'react';
import { Button, Typography } from '@kareo/design-system';
import { refreshPage } from 'shared-assets/facesheet-ui/utils/patientHelper';
var AlertButton = function () {
    return (React.createElement(Button, { variant: "text", size: "small", color: "inherit", onClick: refreshPage },
        React.createElement(Typography, { component: "div" }, "REFRESH PAGE")));
};
export default AlertButton;
